/*
 * Уведомление на главной: GitLab платформы нужно срочно обновить (сервис проверки версий GitLab
 * отвечает danger или в версии критическая уязвимость) — со ссылкой на страницу ресурса gitlab.
 * В остальных случаях, в том числе при ошибке запроса сводки, ничего не показывает (и не занимает
 * места в сетке главной — элемент сетки рендерится только вместе с уведомлением).
 */
import { Grid, Typography } from '@material-ui/core';
import { Link, WarningPanel } from '@backstage/core-components';
import { discoveryApiRef, fetchApiRef, useApi } from '@backstage/core-plugin-api';
import useAsync from 'react-use/esm/useAsync';
import {
  fetchGitlabSummary,
  fetchUpgrades,
  needsAttention,
  updateView,
} from '../../lib/gitlab';

export const GitlabUpdateNotice = () => {
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);
  const { value } = useAsync(
    () => fetchGitlabSummary({ discoveryApi, fetchApi }).catch(() => undefined),
    [],
  );
  const upgrades = useAsync(
    () => fetchUpgrades({ discoveryApi, fetchApi }).catch(() => undefined),
    [],
  );
  const running = upgrades.value?.running;
  if (running) {
    return (
      <Grid item xs={12}>
        <WarningPanel
          severity="info"
          title={`GitLab платформы обновляется: ${running.from} → ${running.to}${running.dryRun ? ' (пробный запуск)' : ''}`}
        >
          <Typography variant="body2">
            {running.dryRun
              ? 'Пробный запуск: проверки, образ и бэкап, GitLab не перезапускается.'
              : 'GitLab перезапускается: несколько минут не работают вход через GitLab, CI и registry.'}{' '}
            Ход — на <Link to="/catalog/default/resource/gitlab">странице GitLab платформы</Link>.
          </Typography>
        </WarningPanel>
      </Grid>
    );
  }
  if (!value?.update || !needsAttention(value)) {
    return null;
  }
  const view = updateView(value);
  return (
    <Grid item xs={12}>
      <WarningPanel
        severity={view.tone === 'error' ? 'error' : 'warning'}
        title={`GitLab платформы ${value.version ?? ''}: ${view.title.toLowerCase()}`}
      >
        <Typography variant="body2">
          {view.detail ? `${view.detail}. ` : ''}Подробности и порядок обновления — на{' '}
          <Link to="/catalog/default/resource/gitlab">странице GitLab платформы</Link>.
        </Typography>
      </WarningPanel>
    </Grid>
  );
};
